
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Banner',
  // Mis propiedades
  props: {
    // Mensaje a mostrar en el banner
    bannerMessage: String,
    // Tipo de banner: Info, Error o Success
    bannerType: String,
  },
  // Propiedades computadas
  computed: {
    // Ajusta el color del banner
    bannerBackgroundColor() {
      const property = 'background-color:';
      let value = 'blue';
      if (this.bannerType === 'Error') {
        value = 'red';
      } if (this.bannerType === 'Success') {
        value = 'green';
      }
      return property + value;
    },
  },
  // Mis métodos
  methods: {
    // Lanza el evento de limpiar el banner
    clearBannerMessage() {
      this.$emit('clear-banner');
    },
  },
});
